import React, { useCallback, useEffect, useImperativeHandle } from "react"
import { Link } from "react-router-dom"
import { Form, Message } from "semantic-ui-react"
import Loader from "../../../BifrostPageComponent/Loader/Loader"
import { useFeedbackSurvey } from "../hooks/useFeedbackSurvey"

const FeedBackSurvey = ({ setIsLoading, setError }, ref) => {
	const { isLoading, error, fieldError, questions, setResponse, createResponse, checkRequiredAnswer } = useFeedbackSurvey()

	const handleSubmit = () => {
		if (checkRequiredAnswer()) {
			return createResponse()
		}
	}

	const questionsHandler = useCallback(
		(question) => {
			switch (question.type) {
				case "MultiChoice":
					return (
						<Form.Select
							required={question.isRequired}
							error={fieldError.multiChoice}
							key={question.id}
							fluid
							options={question.choices.map((choice) => ({
								key: choice.id,
								text: choice.txt,
								value: choice.id
							}))}
							placeholder={question.rtxt}
							onChange={(e, { value }) => {
								setResponse({ "question_id": question.id, "answer": [value] })
							}}
						/>
					)
				case "TextInput":
					switch (question.properties.data.type) {
						case "MULTI_LINE":
							return (
								<Form.TextArea
									required={question.isRequired}
									error={fieldError.textInput}
									key={question.id}
									placeholder={question.rtxt}
									onInput={(e) => {
										setResponse({ "question_id": question.id, "answer": e.target.value })
									}}
								/>
							)
					}
				default:
					return <Message></Message>
			}
		},
		[questions, fieldError]
	)

	useImperativeHandle(ref, () => ({
		handleSubmit: handleSubmit
	}))

	useEffect(() => {
		setIsLoading(isLoading)
		setError(error)
	}, [isLoading, error])

	return isLoading ? (
		<Loader backgroundColor="white" inverted height="1px" minHeight="20px" />
	) : (
		<Form>
			{questions && questions.length > 0 && !error ? (
				questions.map((question) => questionsHandler(question))
			) : (
				<Message>
					Feedback form currently not available. <br />
					<br />
					Contact us at
					<Link
						to="#"
						onClick={(e) => {
							e.preventDefault()
							window.location.href = "mailto:support@bifrostconnect.com"
						}}
					>
						{" "}
						support@bifrostconnect.com
					</Link>
				</Message>
			)}
		</Form>
	)
}

export default React.forwardRef(FeedBackSurvey)
